import { axiosInstance } from "../axios";
import axios from "axios";

export interface UploadPresignedFileOptions {
  file: File;
  ruta: string;
  fileName: string;
  fileType: string;
  isPublic: boolean;
}

export interface UploadPresignedFileResult {
  llave: string;
  nombre: string;
  url?: string;
}

export interface TrainWithFileKeyOptions {
  key: string;
  brain: string;
  documentId?: number;
  fileName?: string;
}

export interface TrainWithFileKeyResult {
  result: string;
}

export interface DownloadPrivateObjectOptions {
  key: string;
}

export interface DownloadPrivateObjectResult {
  url: string;
}

/**
 * Solicita una URL prefirmada al backend y sube el archivo a S3/GCS.
 * Devuelve la URL de acceso (pública o privada).
 */
export async function uploadPresignedFile({
  file,
  ruta,
  fileName,
  fileType,
  isPublic,
}: UploadPresignedFileOptions): Promise<UploadPresignedFileResult> {
  const presignedRes = await axiosInstance.post(
    "/manejador-documentos/presigned-url",
    {
      fileName: ruta,
      fileType,
      isPublic,
    },
  );

  const { uploadUrl, accessUrl } = presignedRes.data;

  const headers: { [key: string]: string } = {
    "Content-Type": fileType,
  };
  // No enviar ACL: S3 con Block Public Access rechaza el PUT con 403.

  const response = await fetch(uploadUrl, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": fileType },
  });
  if (!response.ok) {
    const body = await response.text();
    throw new Error(`Upload failed ${response.status}: ${body}`);
  }
  return {
    llave: ruta,
    nombre: fileName,
    ...(isPublic && accessUrl ? { url: accessUrl } : {}),
  };
}

export async function trainWithFileKey({
  key,
  brain,
  documentId,
  fileName,
}: TrainWithFileKeyOptions): Promise<TrainWithFileKeyResult> {
  const body: Record<string, unknown> = { key, brain };
  if (documentId != null) body.documentId = documentId;
  if (fileName != null) body.fileName = fileName;
  const trainRes = await axiosInstance.post("/manejador-documentos/train", body);
  const { result } = trainRes.data;
  const response: TrainWithFileKeyResult = {
    result,
  };
  return response;
}

export async function downloadPrivateObject({
  key,
}: DownloadPrivateObjectOptions): Promise<DownloadPrivateObjectResult> {
  const downloadResult = await axiosInstance.post(
    "/manejador-documentos/download",
    {
      key,
    },
  );
  const { url } = downloadResult.data;
  const result: DownloadPrivateObjectResult = {
    url: url,
  };
  return result;
}
